import React, {Component} from 'react';

import { IF } from '../../ui/operators/if';
import './pagination.scss';

export default class Pagination extends Component {

    render() {
        const { first_page, current, last_page} = this.props;
        return (
            <div className="pagination">
                <button 
                    onClick={(current > 1 ? () => this.props.getPage(current - 1) : null)}
                > 
                    {
                        current > 1
                            ?
                            <i className="fa fa-arrow-left"></i>
                            :
                            null
                    }
                    {/* <i className="fa fa-arrow-left"></i> */}
                    {/* &laquo; */}
                </button>
                <IF test={current > 1}>
                    <button onClick={() => this.props.getPage(first_page)}>{first_page}</button>
                    <IF test={current > 2}>
                        <button style={{fontSize: 18}}>...</button>
                    </IF>
                </IF>
                <button className="active">{current}</button>
                <IF test={current < last_page}>
                    <button style={{fontSize: 18}}>...</button>
                    <button onClick={() => this.props.getPage(last_page)}>{last_page}</button>
                </IF>
                <button 
                    onClick={(current < last_page ? () => this.props.getPage(current + 1) : null)}
                >
                    {
                        current < last_page
                        ?
                            <i className="fa fa-arrow-right"></i>
                        :
                            null
                    }
                    
                    {/* &raquo; */}
                </button>
            </div>
        );
    }
}